(function (angular) {
    'use strict';

    angular.module('reports')

        .component('liveChatTimeline', {
            bindings: {
            },
            controller: ["$element", "liveChatService", "chartFactoryService", function ($element, liveChatService, chartFactoryService) {
                var ctrl = this;

                var labels = ['-60 min', '-30 min', '-20 min', '-10 min', '-5 min', '-1 min', '-30 sec', '-20 sec', '-10 sec'];

                /**
                 * 
                 */
                ctrl.updateData = function (data) {
                    if (!angular.equals(ctrl.myChart.data.datasets[0].data, data.timeline)) {
                        ctrl.myChart.data.datasets[0].data = data.timeline;
                        ctrl.myChart.update();
                    }
                }

                var listenerFunc = ctrl.updateData.bind(this);

                /**
                 * 
                 */
                ctrl.$onInit = function () {

                    var canvas = $element.find("canvas");

                    var ctx = canvas[0].getContext("2d");

                    liveChatService.addEventListener(listenerFunc);
                    // Chart.defaults.global.defaultFontColor = "#fff";
                    Chart.elements.Rectangle.prototype.draw = chartFactoryService.roundedCornersBars;

                    ctrl.myChart = new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: labels,
                            datasets: [{
                                label: 'New Chats',
                                data: [],
                                backgroundColor: "#15A8FE"
                            }],
                        },
                        options: {
                            plugins: {
                                datalabels: {
                                    display: false
                                }
                            },
                            responsive: true,
                            legend: {
                                display: false,
                            },
                            title: {
                                display: true,
                                text: 'New inbound messages'
                            },
                            animation: {
                                animateScale: true,
                                animateRotate: true
                            },
                            scales: {
                                xAxes: [{
                                    barPercentage: 0.2
                                }],
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true,
                                        userCallback: function (label, index, labels) {
                                            // when the floored value is the same as the value we have a whole number
                                            if (Math.floor(label) === label) {
                                                return label;
                                            }

                                        },
                                    }
                                }],

                            }
                        },
                    });


                }

                /**
                 * 
                 */
                ctrl.$onDestroy = function () {
                    liveChatService.removeEventListener(listenerFunc);
                }

            }],
            template: '<div class="col-md-12"><canvas height="75" ></canvas></div>'
        })

})(window.angular);